var map = {
	"./oxidative-stress.svg": "478d",
	"./pimples.svg": "07ee",
	"./skin-appearance.svg": "d601a",
	"./skin-dryness.svg": "1f84",
	"./skin-oiliness.svg": "cb2df",
	"./skin-pigmentation.svg": "3b04",
	"./skin-redness.svg": "2c132",
	"./skin-texture.svg": "7289"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8951";